import { Component, OnInit, EventEmitter } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {Title} from '@angular/platform-browser';
import {Router, ActivatedRoute} from '@angular/router';
import {MdSnackBar} from '@angular/material';
import {ValidationService} from '../../common/validation.service';
import {AuthenticationService} from '../../auth/authentication.service';
import {JwtHelper} from 'angular2-jwt';
import {AppSettings} from '../../app-settings';
import { UserService } from '../../common/user.service';

@Component({
  selector: 'login-form',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css', '../../app.component.css'],
  providers: [AppSettings, ValidationService, AuthenticationService, JwtHelper, FormBuilder, UserService]
})
export class LoginComponent implements OnInit {

  active_section = 'login';
  email = '';
  password = '';
  token: any;
  loginForm: any;
  errorMessage = '';
  spinner: boolean = false;
  forgotEmail = '';

  constructor(private title: Title, private router: Router, private auth: AuthenticationService, private route: ActivatedRoute, public snackBar: MdSnackBar, private formBuilder: FormBuilder, private userService: UserService){
        this.loginForm = this.formBuilder.group({
            'email': ['', [Validators.required]],
            'password': ['', Validators.required],
            'deviceType': ['2'],
            'deviceId': ['dev1'],
            'deviceToken': ['dev1']
        });
  }

  ngOnInit() {
        if (this.auth.loggedIn()) {
	    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
	    if(userInfo.type=='Administrator')
	    this.router.navigate(['/admin-event-listing']);
	    else if(userInfo.type=='Distributor')
	    this.router.navigate(['/distributor-profile']);
	    else if(userInfo.type=='Supplier')
	    this.router.navigate(['/supplier-profile']);
	    else if(userInfo.type=='Guest')
	    this.router.navigate(['/guest-profile']);
        }

        this.route.queryParams.subscribe(
            data => {
                if (data['email'] && data['password']) {
                    this.loginForm.setValue({
                        email: data['email'],
                        password: atob(data['password'])
                    });
                    this.login();
                }
            }
        );
  }

  onLogin = new EventEmitter();

  changeSection(sec){
   this.active_section = sec;
  }

    login(){
	this.spinner = true;
        this.auth.login(this.loginForm.value)
            .subscribe(response => {
		    this.spinner = false;
                    if(response.status){
                        this.snackBar.open('Successfully Logged In', '', {duration: 4000});
    			this.onLogin.emit();
	    		var userInfo = JSON.parse(localStorage.getItem('userInfo'));
	    		if(userInfo.type=='Administrator')
	    		this.router.navigate(['/admin-event-listing']);
	    		else if(userInfo.type=='Distributor')
	   		this.router.navigate(['/distributor-profile']);
	    		else if(userInfo.type=='Supplier')
	    		this.router.navigate(['/supplier-profile']);
	    		else if(userInfo.type=='Guest')
	    		this.router.navigate(['/guest-profile']);
                    } else {
                        this.snackBar.open(response.message, '', {duration: 4000});
                    }
                },
                error => {
		            this.spinner = false;
                    this.snackBar.open('Username or password is incorrect', '', {duration: 4000});
                }
            );
    }

    userInfo() {
        this.auth.userInfo()
            .subscribe(
                response => {
                },
                error => {
                },
                () => {
                    let type = parseInt(sessionStorage.getItem('userType'));
                })
    }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhone(phone){
   var re = /^[0-9]{10}$/;
   return re.test(phone);
  }

  formValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   if(flag && !this.validateEmail(this.loginForm.value.email) && !this.validatePhone(this.loginForm.value.email))
   flag = false;
   return flag;
  }

  forgotFormValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   if(flag && !this.validateEmail(this.forgotEmail) && !this.validatePhone(this.forgotEmail))
   flag = false;
   return flag;
  }

  forgotPassword(){
   this.spinner = true;
   this.userService.forgotPassword({email:this.forgotEmail}).subscribe(
    response => {
     this.spinner = false;
     this.snackBar.open(response.message, '', {duration: 4000});
     if(response.status)
     this.active_section = 'login';
    },
    error => {
     this.spinner = false;
     this.snackBar.open(error, '', {duration: 4000});
    }
   );
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/home/login/login.component.ts